import React, { useState } from "react";
import {
  ToggleButton,
  ToggleButtonGroup,
  Box,
  Paper,
  Typography,
  Grid,
} from "@mui/material";

import CandidateSpecialization from "../master/candidate-specialization";
import EmployerSpecialization from "../master/employer-specialization";

const Settings = () => {
  const [userType, setUserType] = useState("candidate");

  const handleChange = (event, newUserType) => {
    if (newUserType !== null) {
      setUserType(newUserType);
    }
  };

  return (
    <Grid maxWidth="xl" sx={{ marginX: "auto", paddingY: 2, paddingX: 2 }}>
      <Box>
        <ToggleButtonGroup
          value={userType}
          exclusive
          onChange={handleChange}
          aria-label="User Type"
        >
          <ToggleButton
            value="candidate"
            aria-label="Candidate"
            selected={userType === "candidate"}
            sx={{
              "&.Mui-selected": {
                backgroundColor: "primary.main",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "primary.dark",
                },
              },
            }}
          >
            Candidate Specialization
          </ToggleButton>
          <ToggleButton
            value="employer"
            aria-label="Employer"
            selected={userType === "employer"}
            sx={{
              "&.Mui-selected": {
                backgroundColor: "primary.main",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "primary.dark",
                },
              },
            }}
          >
            Employer Specialization
          </ToggleButton>
        </ToggleButtonGroup>

        {userType === "candidate" && <CandidateSpecialization />}
        {userType === "employer" && <EmployerSpecialization />}
      </Box>
    </Grid>
  );
};

export default Settings;
